// removed by extract-text-webpack-plugin
module.exports = {"cover":"_2AhwFDv15R2KBBMtCfwZ4J","intro":"RyPwhgmPei6WWO32jw5Fq","media":"_7S6JLQcQwDeEngGmcg0iQ"};


//////////////////
// WEBPACK FOOTER
// ../components/project/intro/styles.module.css
// module id = 494
// module chunks = 0